<template>
    <div class="goodsList">
         <div class="goods-item" v-for="item in list" :key="item.id" @click="toDetail(item)">
            <div class="item-top">
                <!-- <img :src="item.picUrl?item.picUrl:''"/> -->
                <van-image
                            fit="contain"
                            :src="item.picUrl?item.picUrl:''"
                        />
            </div>
            <div class="item-middle">
                <div class="name">{{item.name}}</div>
                <div class="tag">
                    <div v-for="(tag,index) in item.labels" :key="tag">
                        <div class="tag-it" v-if="index<2" >{{tag}}</div>
                    </div>
                </div>
                <div class="price-box">
                    <div class="price-sale" v-if="item.priceType==0">¥{{item.salePrice}}</div>
                    <div class="price-sale" v-else-if="item.priceType==1">免费</div>
                    <div class="price-sale" v-else-if="item.priceType==2">¥{{item.salePrice}}</div>
                    <div class="sale-num">已售{{item.sales}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import Clipboard from 'clipboard';
import { Toast } from 'vant';
export default {
    name: "goodsList",
    data() {
        return {
        };
    },
    props:{
        list:{
            type: Array,
            default() {
                return [];
            }
        },
        type:{
            type: Number,
            default() {
                return 0;
            }
        },
    },
    methods: {
        toDetail(item){
            if(!this.type){
                this.$router.push({
                    path:'/entityGoodsDetail',
                    query:{
                        goodsId:item.id,
                        goodsKinds:3,
                        visit_referrer:this.$route.query.visit_referrer?this.$route.query.visit_referrer:''
                    }
                })
            }else{
                location.href=`/entityGoodsDetail?goodsId=${item.id}&goodsKinds=3&visit_referrer=${this.$route.query.visit_referrer?this.$route.query.visit_referrer:''}`;
            }
        }
    },
    mounted() {
    }
};
</script>
<style scoped lang="less">
.goodsList{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .goods-item{
        width: 331px;
        height: 513px;;
        background: #FFFFFF;
        border-radius: 14px;
        border: 1px solid #EAEAEA;
        margin-bottom: 24px;
        overflow: hidden;
        .item-top{
            background: #F8FAFC;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 331px;
            height: 331px;
            /deep/.van-image{
                height: 100%;
            }
            img{
                height: 100%;
                display: block;
            }
        }
        .item-middle{
            padding: 16px 16px 0;
            .name{
                height: 42px;
                font-size: 30px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 42px;
                margin-bottom: 8px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .tag{
                margin-bottom: 32px;
                height: 36px;
                line-height: 36px;
                display: flex;
                align-items: center;
                .tag-it{
                    background: rgba(31, 148, 255, 0.12);
                    border-radius: 4px;
                    font-size: 20px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #1F94FF;
                    margin-right: 8px;
                    font-style: normal;
                    display: inline-block;
                    padding: 8px 12px;
                    line-height: 20px;
                    height: 36px;
                    box-sizing: border-box;
                    max-width: 140px;
                    white-space:nowrap;
                    overflow:hidden;
                    text-overflow:ellipsis;
                }
            }
            .price-box{
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-bottom: 16px;
                .price-sale{
                    height: 32px;
                    font-size: 32px;
                    font-family: AvenirNext-DemiBold, AvenirNext;
                    font-weight: 600;
                    color: #FE5746;
                    line-height: 32px;
                }
                .sale-num{
                    height: 28px;
                    font-size: 20px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    line-height: 28px;
                }
            }
        }
    }
}
</style>
